export const iconButtonStyle = (bgColor: string) => {
  return {
    background: bgColor,
    width: 30,
    height: 30,
    margin: "0 .25rem",
    padding: ".2rem",
  };
};
